// extracted by mini-css-extract-plugin
export default {"section":"Section_section__0XkUm","sectionContent":"Section_sectionContent__iQ5e-"};